import { createSignal, For, Show } from "solid-js";
import { Portal, render } from "solid-js/web";

type NotificationOptions = HtmlNotficationOptions | TextNotificationOptions;

interface HtmlNotficationOptions {
	message: string;
	onclick?: () => void;
	useHtml: true;
}

interface TextNotificationOptions {
	message: string | HTMLElement;
	onclick?: () => void;
	useHtml?: false;
}

const [notificationssolid, setNotifications] = createSignal<NotificationOptions[]>([]);

function Notification() {
	return (
		<Portal>
			<div class="notifications" classList={{ hide: notificationssolid().length === 0 }}>
				<div
					class="notifications-clear-all"
					classList={{ hide: notificationssolid().length === 0 }}
					onclick={() => {
						setNotifications([]);
					}}
				>
					Clear All
				</div>
				<For each={notificationssolid()}>
					{(notification) => (
						<div class="notification">
							<Show
								fallback={
									<div
										class="notification-message"
										innerHTML={notification.message as string}
										onclick={() => {
											if (notification.onclick) {
												setNotifications((prev) => prev.filter((n) => n !== notification));
												notification.onclick();
											}
										}}
									/>
								}
								when={!notification.useHtml}
							>
								<div
									class="notification-message"
									onclick={() => {
										if (notification.onclick) {
											setNotifications((prev) => prev.filter((n) => n !== notification));
											notification.onclick();
										}
									}}
								>
									{notification.message}
								</div>
							</Show>
							<div
								class="notification-close"
								onclick={() => {
									setNotifications((prev) => prev.filter((n) => n !== notification));
								}}
							></div>
						</div>
					)}
				</For>
			</div>
		</Portal>
	);
}

render(() => <Notification />, document.body.appendChild(document.createElement("div")));

export function createNotification(options: NotificationOptions) {
	setNotifications((prev) => [...prev, options]);
}

export function pageBgNotification(options: NotificationOptions) {
	createNotification(options);
}
